export default {
    data() {
        return {
        }
    },
    mounted() {
    },
    methods: {
        makePayment(gateway_order_id, payment_method) {
            console.log("makePayment gateway_order_id: " + gateway_order_id);
            var params = {
                order_id: gateway_order_id,
                extra3: payment_method,
            };

            console.log("makePayment params: " + JSON.stringify(params));

            checkout.postMessage(JSON.stringify(params));
        },

        updateInfo(gateway_order_id) {
            app.gateway_order_id = gateway_order_id;
            app.redirectToPaymentStatus();
            return true;
        },
    }
}